var map = {
	"./Logistics/帐篷.svg": "9f06",
	"./Logistics/录音.svg": "747b",
	"./Logistics/海关.svg": "a5e4",
	"./Logistics/港口.svg": "cd6d",
	"./Logistics/虚线.svg": "f8c5",
	"./img/back.svg": "a11e",
	"./img/downArrow.svg": "b931",
	"./img/home.svg": "e3e6",
	"./img/rightArrow.svg": "8490",
	"./img/upArrow.svg": "a9dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";